import { render, staticRenderFns } from "./EditCatalogueItem.vue?vue&type=template&id=e6e0e134&scoped=true&"
import script from "./EditCatalogueItem.vue?vue&type=script&lang=js&"
export * from "./EditCatalogueItem.vue?vue&type=script&lang=js&"
import style0 from "./EditCatalogueItem.vue?vue&type=style&index=0&id=e6e0e134&scoped=true&lang=scss&"
import style1 from "./EditCatalogueItem.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6e0e134",
  null
  
)

export default component.exports